var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2862 29.0303C109.161 25.8433 125.052 30.2294 136.896 39.7085C141.689 43.5414 145.833 48.2161 148.961 53.5234C155.926 65.3345 158.16 79.655 156.454 93.2872C154.748 106.92 149.279 119.895 141.862 131.423C136.18 140.254 129.22 148.428 120.481 154.185C111.741 159.942 101.076 163.135 90.7432 161.629C81.7834 160.324 73.6005 155.617 66.6536 149.765C51.3059 136.834 41.194 117.852 38.6168 97.8507C36.6117 82.2888 39.349 65.5462 48.9833 53.2269C59.6359 39.6052 76.6868 33.382 92.8428 29.3638C93.3231 29.2447 93.8033 29.1335 94.2862 29.0303Z",
    fill: "#F7CFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.113 41.7939L61.2988 145.586",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6552 34C55.6634 34.8441 27.1721 64.6305 28.0184 100.528C28.8357 135.239 56.8551 163.182 91.6579 164C127.652 164 164 127.619 164 91.8479C163.968 58.8614 131.127 34 91.6552 34Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlocked);
export default __webpack_public_path__ + "static/media/icon-blocked.ba540b21be5c1386c1ce6b6f2facf75e.svg";
export { ForwardRef as ReactComponent };